<template>
  <div>
    <span :class="{ 'text-left': true, 'required': required }">
      {{ label }}
    </span>
    <v-textarea
      v-model="textValue"
      class="input-control"
      :required="required"
      outlined
      :height="height"
      hide-details
    ></v-textarea>
  </div>
</template>

<script>
export default {
  name: "LabelTextArea",
  props: {
    label: String,
    placeholder: String,
    required: Boolean,
    unit: String,
    height: {
      type: Number,
      default: 116
    },
  },
  data() {
    return {
      textValue: ''
    }
  }
}
</script>

<style scoped>
span {
  display: flex;
  font-size: 0.75rem;
  font-weight: bold;
  color: #b0bac9;
  padding-bottom: 0.5rem;
}

.required::after {
  content: "*";
  margin-left: 0.25rem;
  color: red;
}
</style>